import config from "../../Config";
import Config from "../../Config";

const navigationModule = {
  redirectTo: (path) => {
    window.location = path;
  },

  gotoLogin: () => {
    window.location =
      Config.relativePath + "/login?nextScreen=" + window.location.pathname;
  },

  matchCurrentPath: (path) => {
    if (!path) return false;

    let r1 = new RegExp(`^${Config.relativePath}${path}/+.*`);

    return !!(window.location.pathname + "/").match(r1);
  },

  getQueries: () => {
    let searchParams = new URLSearchParams(window.location.search);
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  },

  getQuery: (key) => {
    let searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(key);
  },

  addQuery: (params = {}, navigate) => {
    let pathname = stripBasePath(window.location.pathname, config.relativePath);
    let searchParams = new URLSearchParams(window.location.search);

    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        const value = params[key];
        searchParams.set(key, value);
      }
    }

    let url = `${pathname}?${searchParams.toString()}`;
    navigate(url);
  },

  navigate(pathname, navigate, params = {}) {
    let searchParams = new URLSearchParams();
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        const value = params[key];
        searchParams.set(key, value);
      }
    }
    let url = `${pathname}?${searchParams.toString()}`;
    navigate(url);
  },

  removeQuery: (keys, navigate) => {
    let searchParams = new URLSearchParams(window.location.search);
    let pathname = stripBasePath(window.location.pathname, config.relativePath);

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      searchParams.delete(key);
    }

    let url = `${pathname}?${searchParams.toString()}`;
    navigate(url);
  },
};

function stripBasePath(pathname, appRelativePath) {
  if (!pathname) return "/";

  // Normalize pathname to always start with '/'
  if (!pathname.startsWith("/")) {
    pathname = "/" + pathname;
  }

  // Normalize base path: remove leading & trailing slashes
  const base = appRelativePath
    ? "/" + appRelativePath.replace(/^\/+|\/+$/g, "")
    : "";

  if (!base) return pathname;

  if (pathname === base || pathname === base + "/") {
    return "/";
  }

  if (pathname.startsWith(base + "/")) {
    return pathname.slice(base.length);
  }

  return pathname;
}

export default navigationModule;
